module.exports = __webpack_public_path__ + "static/media/logo-light.de9420be.png";